import Breadcrumb from './breadcrumb.element.js';
import '../wje-button/button.js';
import '../wje-dropdown/dropdown.js';
import '../wje-icon/icon.js';
import '../wje-menu/menu.js';
import '../wje-menu-item/menu-item.js';
import '../wje-popup/popup.js';
import '../wje-tooltip/tooltip.js';

// export * from "./breadcrumb.element.js";
export default Breadcrumb;

Breadcrumb.define('wje-breadcrumb', Breadcrumb);
